// // File Path: frontend/src/component/DocumentUpload.jsx
// import React, { useMemo, useState } from 'react';
// import {
//   Container,
//   Box,
//   Typography,
//   Paper,
//   Button,
//   Alert,
//   Grid,
//   Chip,
//   Skeleton,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Divider,
//   Stack,
//   useTheme,
//   alpha
// } from '@mui/material';
// import {
//   CloudUpload as CloudUploadIcon,
//   Verified as VerifiedIcon,
//   Pending as PendingIcon,
//   Visibility as VisibilityIcon,
//   Delete as DeleteIcon,
//   DeleteSweep as DeleteSweepIcon,
//   Shield as ShieldIcon,
//   InsertDriveFile as InsertDriveFileIcon,
//   Warning as WarningIcon
// } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// // import { getUserIdFromToken } from '../../utils/authUtils';
// import DocumentViewerModal from './Components/DocumentViewerModal';
// import DocumentTypeDropdown from './Components/DocumentTypeDropdown';
// import { useDocument } from './hooks/useDocument.ts';
// import { getUserIdFromToken } from '../../Utilities/authUtils';

// const StyledButton = styled(Button)(({ theme }) => ({
//   backgroundColor: '#0044C6',
//   '&:hover': {
//     backgroundColor: '#0036a0',
//   },
//   '&:disabled': {
//     backgroundColor: alpha('#0044C6', 0.6),
//   },
// }));

// const DocumentUpload = () => {
//   const dynamicUserId = useMemo(() => getUserIdFromToken(), []);
//   const [viewingDocUrl, setViewingDocUrl] = useState(null);
//   const theme = useTheme();

//   const {
//     documents,
//     isLoading,
//     formState,
//     handleFileChange,
//     handleDocumentTypeChange,
//     handleUpload,
//     handleDeleteDocument,
//     handleDeleteAllDocuments,
//     initiateDigilockerVerification,
//     initiateDigilockerVerifyAll
//   } = useDocument(dynamicUserId);

//   if (!dynamicUserId) {
//     return (
//       <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4 }}>
//         <Alert severity="error" sx={{ borderRadius: 3, border: '1px solid #fecaca' }}>
//           Authentication Error: No valid token found in Local Storage.
//         </Alert>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', py: 6, px: { xs: 2, sm: 3, lg: 4 } }}>
//       <Container maxWidth="lg" disableGutters>
//         <Box sx={{ maxWidth: '900px', mx: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>

//           {/* Header Section */}
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
//             <Box>
//               <Typography variant="h3" component="h1" sx={{ fontWeight: 800, letterSpacing: '-0.02em', fontSize: { xs: '1.875rem', sm: '2.25rem' } }}>
//                 Identity Verification
//               </Typography>
//               <Typography variant="body1" sx={{ mt: 0.5, color: '#64748b' }}>
//                 Securely upload your official documents.
//               </Typography>
//             </Box>
//             <Chip
//               label={`User ID: ${dynamicUserId}`}
//               sx={{
//                 bgcolor: '#dbeafe',
//                 color: '#1e40af',
//                 fontWeight: 600,
//                 borderRadius: 2,
//                 border: '1px solid #bfdbfe',
//                 display: { xs: 'none', sm: 'flex' }
//               }}
//             />
//           </Box>

//           {/* Upload Form Section */}
//           <Paper
//             elevation={0}
//             sx={{
//               borderRadius: 3,
//               border: '1px solid #e2e8f0',
//               overflow: 'hidden',
//               boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.05)'
//             }}
//           >
//             <Box sx={{ px: 3, py: 2.5, borderBottom: '1px solid #f1f5f9', bgcolor: '#f8fafc' }}>
//               <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
//                 Upload New Document
//               </Typography>
//             </Box>

//             <Box component="form" onSubmit={handleUpload} sx={{ p: { xs: 3, sm: 4 } }}>
//               <Grid container spacing={3}>
//                 <Grid item xs={12} md={6}>
//                   <DocumentTypeDropdown
//                     value={formState.documentTypeCode}
//                     onChange={handleDocumentTypeChange}
//                   />
//                 </Grid>

//                 <Grid item xs={12} md={6}>
//                   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//                     <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
//                       Select File
//                     </Typography>
//                     <Button
//                       component="label"
//                       variant="outlined"
//                       startIcon={<CloudUploadIcon />}
//                       sx={{
//                         justifyContent: 'flex-start',
//                         py: 1.5,
//                         borderRadius: 2,
//                         borderColor: '#cbd5e1',
//                         bgcolor: '#f8fafc',
//                         textTransform: 'none',
//                         fontWeight: 500,
//                         '&:hover': {
//                           borderColor: '#0044C6',
//                           bgcolor: alpha('#0044C6', 0.04)
//                         }
//                       }}
//                     >
//                       {formState.file ? formState.file.name : 'Choose file'}
//                       <input
//                         type="file"
//                         hidden
//                         onChange={handleFileChange}
//                         accept=".pdf,.jpg,.jpeg,.png"
//                       />
//                     </Button>
//                     <Typography variant="caption" sx={{ color: '#64748b' }}>
//                       Supported: PDF, JPG, JPEG, PNG
//                     </Typography>
//                   </Box>
//                 </Grid>
//               </Grid>

//               <Box sx={{ mt: 4, pt: 1 }}>
//                 <StyledButton
//                   type="submit"
//                   disabled={isLoading || !formState.file}
//                   variant="contained"
//                   sx={{
//                     px: 4,
//                     py: 1.5,
//                     fontSize: '0.875rem',
//                     fontWeight: 600,
//                     textTransform: 'none',
//                     borderRadius: 2,
//                     width: { xs: '100%', sm: 'auto' }
//                   }}
//                 >
//                   {isLoading ? 'Processing & Extracting...' : 'Securely Upload Document'}
//                 </StyledButton>
//               </Box>
//             </Box>
//           </Paper>

//           {/* Documents List Section */}
//           <Box sx={{ pt: 2 }}>
//             <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { sm: 'center' }, gap: 2, mb: 3 }}>
//               <Typography variant="h5" sx={{ fontWeight: 700 }}>
//                 My Uploaded Documents
//               </Typography>
//               <Stack direction="row" spacing={1.5}>
//                 {documents && documents.length > 0 && documents.some(doc => !doc.is_verified) && (
//                   <Button
//                     onClick={initiateDigilockerVerifyAll}
//                     startIcon={<ShieldIcon />}
//                     variant="outlined"
//                     sx={{
//                       borderColor: '#c7d2fe',
//                       color: '#6366f1',
//                       bgcolor: '#f8fafc',
//                       textTransform: 'none',
//                       fontWeight: 600,
//                       fontSize: '0.75rem',
//                       px: 2,
//                       py: 1,
//                       '&:hover': {
//                         borderColor: '#a5b4fc',
//                         bgcolor: '#f1f5f9'
//                       }
//                     }}
//                   >
//                     Verify All with DigiLocker
//                   </Button>
//                 )}
//                 {documents && documents.length > 0 && (
//                   <Button
//                     onClick={handleDeleteAllDocuments}
//                     startIcon={<DeleteSweepIcon />}
//                     variant="outlined"
//                     sx={{
//                       borderColor: '#fecaca',
//                       color: '#ef4444',
//                       bgcolor: '#fef2f2',
//                       textTransform: 'none',
//                       fontWeight: 600,
//                       fontSize: '0.75rem',
//                       px: 2,
//                       py: 1,
//                       '&:hover': {
//                         borderColor: '#fca5a5',
//                         bgcolor: '#fee2e2'
//                       }
//                     }}
//                   >
//                     Delete All
//                   </Button>
//                 )}
//               </Stack>
//             </Box>

//             {isLoading && documents?.length === 0 ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
//                 <Stack spacing={2} alignItems="center">
//                   <Skeleton variant="circular" width={48} height={48} />
//                   <Skeleton variant="text" width={128} height={24} />
//                 </Stack>
//               </Box>
//             ) : documents && documents.length > 0 ? (
//               <Stack spacing={2}>
//                 {documents.map((doc, index) => (
//                   <Paper
//                     key={index}
//                     elevation={0}
//                     sx={{
//                       p: 2.5,
//                       border: '1px solid #e2e8f0',
//                       borderRadius: 3,
//                       transition: 'all 0.2s',
//                       '&:hover': {
//                         borderColor: alpha('#0044C6', 0.3),
//                         boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05)'
//                       }
//                     }}
//                   >
//                     {/* Top Row */}
//                     <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { sm: 'center' }, gap: 2 }}>
//                       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                         <Box
//                           sx={{
//                             p: 1.5,
//                             bgcolor: alpha('#0044C6', 0.08),
//                             borderRadius: 2,
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center'
//                           }}
//                         >
//                           <InsertDriveFileIcon sx={{ color: '#0044C6' }} />
//                         </Box>
//                         <Box>
//                           <Typography variant="body2" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.025em' }}>
//                             {doc.type?.name || doc.document_type_id}
//                           </Typography>
//                           <Box sx={{ mt: 0.75 }}>
//                             {doc.is_verified ? (
//                               <Chip
//                                 icon={<VerifiedIcon sx={{ fontSize: 12 }} />}
//                                 label="Verified by DigiLocker"
//                                 size="small"
//                                 sx={{
//                                   bgcolor: '#ecfdf5',
//                                   color: '#059669',
//                                   borderRadius: 1,
//                                   fontSize: '0.7rem',
//                                   fontWeight: 600,
//                                   height: 24,
//                                   border: '1px solid #d1fae5'
//                                 }}
//                               />
//                             ) : (
//                               <Chip
//                                 icon={<PendingIcon sx={{ fontSize: 12 }} />}
//                                 label="Awaiting Verification"
//                                 size="small"
//                                 sx={{
//                                   bgcolor: '#fffbeb',
//                                   color: '#d97706',
//                                   borderRadius: 1,
//                                   fontSize: '0.7rem',
//                                   fontWeight: 600,
//                                   height: 24,
//                                   border: '1px solid #fef3c7'
//                                 }}
//                               />
//                             )}
//                           </Box>
//                         </Box>
//                       </Box>

//                       <Stack direction="row" spacing={1.5} sx={{ width: { xs: '100%', sm: 'auto' } }}>
//                         {!doc.is_verified && (
//                           <Button
//                             onClick={() => initiateDigilockerVerification(doc.id)}
//                             startIcon={<ShieldIcon />}
//                             sx={{
//                               bgcolor: '#0044C6',
//                               color: 'white',
//                               textTransform: 'none',
//                               fontWeight: 600,
//                               fontSize: '0.75rem',
//                               px: 2,
//                               py: 1,
//                               flex: { xs: 1, sm: 'none' },
//                               '&:hover': {
//                                 bgcolor: '#0036a0'
//                               }
//                             }}
//                           >
//                             Verify
//                           </Button>
//                         )}
//                         <Button
//                           onClick={() => setViewingDocUrl(doc.file_url)}
//                           startIcon={<VisibilityIcon />}
//                           variant="outlined"
//                           sx={{
//                             borderColor: '#cbd5e1',
//                             color: '#475569',
//                             textTransform: 'none',
//                             fontWeight: 600,
//                             fontSize: '0.75rem',
//                             px: 2,
//                             py: 1,
//                             flex: { xs: 1, sm: 'none' },
//                             '&:hover': {
//                               borderColor: '#94a3b8',
//                               bgcolor: '#f8fafc'
//                             }
//                           }}
//                         >
//                           View File
//                         </Button>
//                         <IconButton
//                           onClick={() => handleDeleteDocument(doc.id)}
//                           size="small"
//                           sx={{
//                             color: '#94a3b8',
//                             border: '1px solid #e2e8f0',
//                             borderRadius: 1.5,
//                             '&:hover': {
//                               color: '#ef4444',
//                               borderColor: '#fecaca',
//                               bgcolor: '#fef2f2'
//                             }
//                           }}
//                         >
//                           <DeleteIcon sx={{ fontSize: 18 }} />
//                         </IconButton>
//                       </Stack>
//                     </Box>

//                     {/* OCR Data Table */}
//                     {doc.ocrData && doc.ocrData.length > 0 && (
//                       <Box sx={{ mt: 3, pt: 2.5, borderTop: '1px solid #f1f5f9' }}>
//                         <Typography variant="caption" sx={{ fontWeight: 700, color: '#94a3b8', letterSpacing: '0.05em', textTransform: 'uppercase', mb: 1.5, display: 'block' }}>
//                           Extracted Data
//                         </Typography>
//                         <TableContainer>
//                           <Table size="small">
//                             <TableHead>
//                               <TableRow sx={{ bgcolor: '#f8fafc' }}>
//                                 <TableCell sx={{ fontWeight: 600, color: '#64748b', py: 1.5, borderBottom: '1px solid #f1f5f9' }}>
//                                   Field Name
//                                 </TableCell>
//                                 <TableCell sx={{ fontWeight: 600, color: '#64748b', py: 1.5, borderBottom: '1px solid #f1f5f9' }}>
//                                   Value
//                                 </TableCell>
//                               </TableRow>
//                             </TableHead>
//                             <TableBody>
//                               {doc.ocrData.map((ocr, i) => (
//                                 <TableRow key={i} sx={{ '&:hover': { bgcolor: alpha('#f8fafc', 0.5) } }}>
//                                   <TableCell sx={{ py: 1.25, fontWeight: 500, textTransform: 'capitalize' }}>
//                                     {ocr.property_key.replace(/_/g, ' ')}
//                                   </TableCell>
//                                   <TableCell sx={{ py: 1.25, fontFamily: 'monospace', fontSize: '0.75rem' }}>
//                                     {ocr.property_value}
//                                   </TableCell>
//                                 </TableRow>
//                               ))}
//                             </TableBody>
//                           </Table>
//                         </TableContainer>
//                       </Box>
//                     )}
//                   </Paper>
//                 ))}
//               </Stack>
//             ) : (
//               <Paper
//                 elevation={0}
//                 sx={{
//                   textAlign: 'center',
//                   py: 8,
//                   border: '2px dashed #e2e8f0',
//                   borderRadius: 3,
//                   bgcolor: 'transparent'
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 64,
//                     height: 64,
//                     borderRadius: '50%',
//                     bgcolor: '#f8fafc',
//                     mb: 2
//                   }}
//                 >
//                   <InsertDriveFileIcon sx={{ fontSize: 32, color: '#94a3b8' }} />
//                 </Box>
//                 <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
//                   No documents yet
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: '#64748b' }}>
//                   Get started by uploading your first identity document.
//                 </Typography>
//               </Paper>
//             )}
//           </Box>
//         </Box>
//       </Container>

//       <DocumentViewerModal
//         viewingDocUrl={viewingDocUrl}
//         onClose={() => setViewingDocUrl(null)}
//       />
//     </Box>
//   );
// };

// export default DocumentUpload;

// File Path: frontend/src/component/DocumentUpload.jsx
import React, { useMemo, useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Alert,
  Grid,
  Chip,
  Skeleton,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Stack,
  useTheme,
  alpha
} from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  Verified as VerifiedIcon,
  Pending as PendingIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
  DeleteSweep as DeleteSweepIcon,
  Shield as ShieldIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Warning as WarningIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
// import { getUserIdFromToken } from '../../utils/authUtils';
import DocumentViewerModal from './Components/DocumentViewerModal';
import DocumentTypeDropdown from './Components/DocumentTypeDropdown';
import { useDocument } from './hooks/useDocument.ts';
import { getUserIdFromToken } from '../../Utilities/authUtils';

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#0044C6',
  '&:hover': {
    backgroundColor: '#0036a0',
  },
  '&:disabled': {
    backgroundColor: alpha('#0044C6', 0.6),
  },
}));

// Mock/Dummy Data for Demo
const MOCK_DOCUMENTS = [
  {
    id: 1,
    type: { name: 'PAN Card' },
    document_type_id: 'PANCR',
    is_verified: true,
    file_url: '/dummy-pan.pdf',
    ocrData: [
      { property_key: 'name', property_value: 'John Doe' },
      { property_key: 'pan_number', property_value: 'ABCDE1234F' },
      { property_key: 'date_of_birth', property_value: '15/03/1990' },
      { property_key: 'father_name', property_value: 'Robert Doe' }
    ]
  },
  {
    id: 2,
    type: { name: 'Aadhaar Card' },
    document_type_id: 'AADHAAR',
    is_verified: true,
    file_url: '/dummy-aadhaar.pdf',
    ocrData: [
      { property_key: 'name', property_value: 'John Doe' },
      { property_key: 'aadhaar_number', property_value: 'XXXX-XXXX-XXXX' },
      { property_key: 'date_of_birth', property_value: '15/03/1990' },
      { property_key: 'gender', property_value: 'Male' },
      { property_key: 'address', property_value: '123 Main Street, Mumbai, Maharashtra - 400001' }
    ]
  },
  {
    id: 3,
    type: { name: 'Driving License' },
    document_type_id: 'DRIVING_LICENSE',
    is_verified: false,
    file_url: '/dummy-license.pdf',
    ocrData: [
      { property_key: 'name', property_value: 'John Doe' },
      { property_key: 'license_number', property_value: 'DL-1234567890' },
      { property_key: 'valid_from', property_value: '01/01/2020' },
      { property_key: 'valid_until', property_value: '31/12/2030' },
      { property_key: 'vehicle_types', property_value: 'LMV, MCWG' }
    ]
  },
  {
    id: 4,
    type: { name: 'Salary Slip' },
    document_type_id: 'SALARY_SLIPS',
    is_verified: false,
    file_url: '/dummy-salary.pdf',
    ocrData: [
      { property_key: 'employee_name', property_value: 'John Doe' },
      { property_key: 'employee_id', property_value: 'EMP001' },
      { property_key: 'month', property_value: 'January 2024' },
      { property_key: 'basic_pay', property_value: '₹50,000' },
      { property_key: 'total_deductions', property_value: '₹12,000' },
      { property_key: 'net_pay', property_value: '₹38,000' }
    ]
  },
  {
    id: 5,
    type: { name: 'Degree Certificate' },
    document_type_id: 'DEGREE_UG',
    is_verified: false,
    file_url: '/dummy-degree.pdf',
    ocrData: [
      { property_key: 'student_name', property_value: 'John Doe' },
      { property_key: 'degree', property_value: 'Bachelor of Technology' },
      { property_key: 'branch', property_value: 'Computer Science' },
      { property_key: 'university', property_value: 'Mumbai University' },
      { property_key: 'year_of_passing', property_value: '2012' },
      { property_key: 'percentage', property_value: '85%' }
    ]
  }
];

const DocumentUpload = () => {
  const dynamicUserId = useMemo(() => getUserIdFromToken(), []);
  const [viewingDocUrl, setViewingDocUrl] = useState(null);
  const [useMockData, setUseMockData] = useState(false);
  const theme = useTheme();

  const {
    documents: apiDocuments,
    isLoading: apiLoading,
    formState,
    handleFileChange,
    handleDocumentTypeChange,
    handleUpload,
    handleDeleteDocument,
    handleDeleteAllDocuments,
    initiateDigilockerVerification,
    initiateDigilockerVerifyAll
  } = useDocument(dynamicUserId);

  // Check if API is available, if not use mock data
  useEffect(() => {
    const checkApiAvailability = async () => {
      try {
        // Try to fetch from API with timeout
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);
        
        const response = await fetch('/api/health-check', { 
          method: 'HEAD',
          signal: controller.signal 
        });
        
        clearTimeout(timeoutId);
        
        if (!response.ok) {
          setUseMockData(true);
        }
      } catch (error) {
        // API not available, use mock data
        console.warn('Backend API not available, using mock data for demo');
        setUseMockData(true);
      }
    };

    // Only check if we're in development mode or if explicitly needed
    if (process.env.NODE_ENV === 'development') {
      checkApiAvailability();
    } else {
      // For production, you might want to use mock data based on a prop or query param
      const urlParams = new URLSearchParams(window.location.search);
      const demo = urlParams.get('demo');
      if (demo === 'true') {
        setUseMockData(true);
      }
    }
  }, []);

  // Use mock data if API is not available
  const documents = useMockData ? MOCK_DOCUMENTS : apiDocuments;
  const isLoading = useMockData ? false : apiLoading;

  // Mock handlers for demo mode
  const mockHandleDeleteDocument = (docId) => {
    if (useMockData) {
      console.log('Mock delete document:', docId);
      alert(`Demo Mode: Document ${docId} would be deleted`);
    } else {
      handleDeleteDocument(docId);
    }
  };

  const mockHandleDeleteAllDocuments = () => {
    if (useMockData) {
      console.log('Mock delete all documents');
      alert('Demo Mode: All documents would be deleted');
    } else {
      handleDeleteAllDocuments();
    }
  };

  const mockInitiateDigilockerVerification = (docId) => {
    if (useMockData) {
      console.log('Mock verify document:', docId);
      alert(`Demo Mode: Document ${docId} would be verified with DigiLocker`);
    } else {
      initiateDigilockerVerification(docId);
    }
  };

  const mockInitiateDigilockerVerifyAll = () => {
    if (useMockData) {
      console.log('Mock verify all documents');
      alert('Demo Mode: All documents would be verified with DigiLocker');
    } else {
      initiateDigilockerVerifyAll();
    }
  };

  const mockHandleUpload = (e) => {
    e.preventDefault();
    if (useMockData) {
      console.log('Mock upload document:', formState);
      alert(`Demo Mode: Document "${formState.file?.name}" would be uploaded`);
      // Reset form state after mock upload
      handleFileChange({ target: { value: '' } });
      handleDocumentTypeChange({ target: { value: '' } });
    } else {
      handleUpload(e);
    }
  };

  if (!dynamicUserId) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4 }}>
        <Alert severity="error" sx={{ borderRadius: 3, border: '1px solid #fecaca' }}>
          Authentication Error: No valid token found in Local Storage.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc', py: 6, px: { xs: 2, sm: 3, lg: 4 } }}>
      <Container maxWidth="lg" disableGutters>
        <Box sx={{ maxWidth: '900px', mx: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>

          {/* Demo Mode Banner */}
          {useMockData && (
            <Alert 
              severity="info" 
              sx={{ 
                borderRadius: 2,
                border: '1px solid #bae6fd',
                bgcolor: '#f0f9ff'
              }}
              icon={<WarningIcon />}
            >
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                Demo Mode: Backend API is not available. Showing sample data for preview.
              </Typography>
            </Alert>
          )}

          {/* Header Section */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
            <Box>
              <Typography variant="h3" component="h1" sx={{ fontWeight: 800, letterSpacing: '-0.02em', fontSize: { xs: '1.875rem', sm: '2.25rem' } }}>
                Identity Verification
              </Typography>
              <Typography variant="body1" sx={{ mt: 0.5, color: '#64748b' }}>
                Securely upload your official documents.
              </Typography>
            </Box>
            <Chip
              label={`User ID: ${dynamicUserId}`}
              sx={{
                bgcolor: '#dbeafe',
                color: '#1e40af',
                fontWeight: 600,
                borderRadius: 2,
                border: '1px solid #bfdbfe',
                display: { xs: 'none', sm: 'flex' }
              }}
            />
          </Box>

          {/* Upload Form Section */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              border: '1px solid #e2e8f0',
              overflow: 'hidden',
              boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.05)'
            }}
          >
            <Box sx={{ px: 3, py: 2.5, borderBottom: '1px solid #f1f5f9', bgcolor: '#f8fafc' }}>
              <Typography variant="h6" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                Upload New Document
              </Typography>
            </Box>

            <Box component="form" onSubmit={mockHandleUpload} sx={{ p: { xs: 3, sm: 4 } }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <DocumentTypeDropdown
                    value={formState.documentTypeCode}
                    onChange={handleDocumentTypeChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                      Select File
                    </Typography>
                    <Button
                      component="label"
                      variant="outlined"
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        justifyContent: 'flex-start',
                        py: 1.5,
                        borderRadius: 2,
                        borderColor: '#cbd5e1',
                        bgcolor: '#f8fafc',
                        textTransform: 'none',
                        fontWeight: 500,
                        '&:hover': {
                          borderColor: '#0044C6',
                          bgcolor: alpha('#0044C6', 0.04)
                        }
                      }}
                    >
                      {formState.file ? formState.file.name : 'Choose file'}
                      <input
                        type="file"
                        hidden
                        onChange={handleFileChange}
                        accept=".pdf,.jpg,.jpeg,.png"
                      />
                    </Button>
                    <Typography variant="caption" sx={{ color: '#64748b' }}>
                      Supported: PDF, JPG, JPEG, PNG
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Box sx={{ mt: 4, pt: 1 }}>
                <StyledButton
                  type="submit"
                  disabled={isLoading || !formState.file}
                  variant="contained"
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    borderRadius: 2,
                    width: { xs: '100%', sm: 'auto' }
                  }}
                >
                  {isLoading ? 'Processing & Extracting...' : 'Securely Upload Document'}
                </StyledButton>
              </Box>
            </Box>
          </Paper>

          {/* Documents List Section */}
          <Box sx={{ pt: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { sm: 'center' }, gap: 2, mb: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                My Uploaded Documents
              </Typography>
              <Stack direction="row" spacing={1.5}>
                {documents && documents.length > 0 && documents.some(doc => !doc.is_verified) && (
                  <Button
                    onClick={mockInitiateDigilockerVerifyAll}
                    startIcon={<ShieldIcon />}
                    variant="outlined"
                    sx={{
                      borderColor: '#c7d2fe',
                      color: '#6366f1',
                      bgcolor: '#f8fafc',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '0.75rem',
                      px: 2,
                      py: 1,
                      '&:hover': {
                        borderColor: '#a5b4fc',
                        bgcolor: '#f1f5f9'
                      }
                    }}
                  >
                    Verify All with DigiLocker
                  </Button>
                )}
                {documents && documents.length > 0 && (
                  <Button
                    onClick={mockHandleDeleteAllDocuments}
                    startIcon={<DeleteSweepIcon />}
                    variant="outlined"
                    sx={{
                      borderColor: '#fecaca',
                      color: '#ef4444',
                      bgcolor: '#fef2f2',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: '0.75rem',
                      px: 2,
                      py: 1,
                      '&:hover': {
                        borderColor: '#fca5a5',
                        bgcolor: '#fee2e2'
                      }
                    }}
                  >
                    Delete All
                  </Button>
                )}
              </Stack>
            </Box>

            {isLoading && documents?.length === 0 ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
                <Stack spacing={2} alignItems="center">
                  <Skeleton variant="circular" width={48} height={48} />
                  <Skeleton variant="text" width={128} height={24} />
                </Stack>
              </Box>
            ) : documents && documents.length > 0 ? (
              <Stack spacing={2}>
                {documents.map((doc, index) => (
                  <Paper
                    key={doc.id || index}
                    elevation={0}
                    sx={{
                      p: 2.5,
                      border: '1px solid #e2e8f0',
                      borderRadius: 3,
                      transition: 'all 0.2s',
                      '&:hover': {
                        borderColor: alpha('#0044C6', 0.3),
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.05)'
                      }
                    }}
                  >
                    {/* Top Row */}
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { sm: 'center' }, gap: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Box
                          sx={{
                            p: 1.5,
                            bgcolor: alpha('#0044C6', 0.08),
                            borderRadius: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <InsertDriveFileIcon sx={{ color: '#0044C6' }} />
                        </Box>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.025em' }}>
                            {doc.type?.name || doc.document_type_id}
                          </Typography>
                          <Box sx={{ mt: 0.75 }}>
                            {doc.is_verified ? (
                              <Chip
                                icon={<VerifiedIcon sx={{ fontSize: 12 }} />}
                                label="Verified by DigiLocker"
                                size="small"
                                sx={{
                                  bgcolor: '#ecfdf5',
                                  color: '#059669',
                                  borderRadius: 1,
                                  fontSize: '0.7rem',
                                  fontWeight: 600,
                                  height: 24,
                                  border: '1px solid #d1fae5'
                                }}
                              />
                            ) : (
                              <Chip
                                icon={<PendingIcon sx={{ fontSize: 12 }} />}
                                label="Awaiting Verification"
                                size="small"
                                sx={{
                                  bgcolor: '#fffbeb',
                                  color: '#d97706',
                                  borderRadius: 1,
                                  fontSize: '0.7rem',
                                  fontWeight: 600,
                                  height: 24,
                                  border: '1px solid #fef3c7'
                                }}
                              />
                            )}
                          </Box>
                        </Box>
                      </Box>

                      <Stack direction="row" spacing={1.5} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                        {!doc.is_verified && (
                          <Button
                            onClick={() => mockInitiateDigilockerVerification(doc.id)}
                            startIcon={<ShieldIcon />}
                            sx={{
                              bgcolor: '#0044C6',
                              color: 'white',
                              textTransform: 'none',
                              fontWeight: 600,
                              fontSize: '0.75rem',
                              px: 2,
                              py: 1,
                              flex: { xs: 1, sm: 'none' },
                              '&:hover': {
                                bgcolor: '#0036a0'
                              }
                            }}
                          >
                            Verify
                          </Button>
                        )}
                        <Button
                          onClick={() => setViewingDocUrl(doc.file_url)}
                          startIcon={<VisibilityIcon />}
                          variant="outlined"
                          sx={{
                            borderColor: '#cbd5e1',
                            color: '#475569',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            px: 2,
                            py: 1,
                            flex: { xs: 1, sm: 'none' },
                            '&:hover': {
                              borderColor: '#94a3b8',
                              bgcolor: '#f8fafc'
                            }
                          }}
                        >
                          View File
                        </Button>
                        <IconButton
                          onClick={() => mockHandleDeleteDocument(doc.id)}
                          size="small"
                          sx={{
                            color: '#94a3b8',
                            border: '1px solid #e2e8f0',
                            borderRadius: 1.5,
                            '&:hover': {
                              color: '#ef4444',
                              borderColor: '#fecaca',
                              bgcolor: '#fef2f2'
                            }
                          }}
                        >
                          <DeleteIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Stack>
                    </Box>

                    {/* OCR Data Table */}
                    {doc.ocrData && doc.ocrData.length > 0 && (
                      <Box sx={{ mt: 3, pt: 2.5, borderTop: '1px solid #f1f5f9' }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#94a3b8', letterSpacing: '0.05em', textTransform: 'uppercase', mb: 1.5, display: 'block' }}>
                          Extracted Data
                        </Typography>
                        <TableContainer>
                          <Table size="small">
                            <TableHead>
                              <TableRow sx={{ bgcolor: '#f8fafc' }}>
                                <TableCell sx={{ fontWeight: 600, color: '#64748b', py: 1.5, borderBottom: '1px solid #f1f5f9' }}>
                                  Field Name
                                </TableCell>
                                <TableCell sx={{ fontWeight: 600, color: '#64748b', py: 1.5, borderBottom: '1px solid #f1f5f9' }}>
                                  Value
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {doc.ocrData.map((ocr, i) => (
                                <TableRow key={i} sx={{ '&:hover': { bgcolor: alpha('#f8fafc', 0.5) } }}>
                                  <TableCell sx={{ py: 1.25, fontWeight: 500, textTransform: 'capitalize' }}>
                                    {ocr.property_key.replace(/_/g, ' ')}
                                  </TableCell>
                                  <TableCell sx={{ py: 1.25, fontFamily: 'monospace', fontSize: '0.75rem' }}>
                                    {ocr.property_value}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    )}
                  </Paper>
                ))}
              </Stack>
            ) : (
              <Paper
                elevation={0}
                sx={{
                  textAlign: 'center',
                  py: 8,
                  border: '2px dashed #e2e8f0',
                  borderRadius: 3,
                  bgcolor: 'transparent'
                }}
              >
                <Box
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 64,
                    height: 64,
                    borderRadius: '50%',
                    bgcolor: '#f8fafc',
                    mb: 2
                  }}
                >
                  <InsertDriveFileIcon sx={{ fontSize: 32, color: '#94a3b8' }} />
                </Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                  No documents yet
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b' }}>
                  Get started by uploading your first identity document.
                </Typography>
              </Paper>
            )}
          </Box>
        </Box>
      </Container>

      <DocumentViewerModal
        viewingDocUrl={viewingDocUrl}
        onClose={() => setViewingDocUrl(null)}
      />
    </Box>
  );
};

export default DocumentUpload;